export default __webpack_public_path__ + "static/media/gucci-sun.3ec494bf.jpg";